import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import React from "react";
import {
  formatCoverValueForDisplay,
  resolveCoverNotation,
} from "./coverFormatter";

const CoverCellRenderer = (params: any) => {
  const fieldName: string = params.fieldName;
  const { fullTradeData } = returnAllTradeDetailsFromGenericParams(params);
  const value = (fullTradeData as any)?.[fieldName];
  const notation = resolveCoverNotation(fullTradeData);
  const display = formatCoverValueForDisplay(value, notation, fullTradeData);

  return (
    <div
      data-testid={`${fieldName}CellContainer`}
      id={`${fieldName}CellContainer`}
      className="justify-center text-center"
      style={{ width: "100%" }}
    >
      {display}
    </div>
  );
};

export default CoverCellRenderer;
